export default __webpack_public_path__ + "static/media/image2.5c833dbb.jpg";